import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { Link } from "react-router-dom";
import stl from "./PaymentFailed.module.css";
import { CDN_LINK } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
var PaymentFailed = function PaymentFailed(_ref) {
  var checkoutOrder = _ref.checkoutOrder,
    offlineToken = _ref.offlineToken;
  var post_id = checkoutOrder.post_id,
    order_id = checkoutOrder.id;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var getButtonLink = function getButtonLink() {
    if (offlineToken) {
      return "/offline-payment/".concat(offlineToken);
    } else {
      return "/checkout/create-araboon?post_id=".concat(post_id, "&order_id=").concat(order_id);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.container].join(" ")
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/eerre.png",
    alt: "Success"
  }), /*#__PURE__*/React.createElement("strong", null, t("payment_process_successfully_completed", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", null, t("error_occurred_re_try", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement(Link, {
    to: createUrl(getButtonLink()),
    className: [stl.btn, "blueBtn"].join(" ")
  }, t("try_again", {
    ns: "web_common"
  }))));
};
export default PaymentFailed;